import {Button} from 'antd';
import moment from 'moment';
import {IComputedExamData} from 'pages/StudentSide/Exams/Exams';
import './styles.less';

const StudentExamCard = ({data}: {data: IComputedExamData}) => {
	return (
		<div className="card-container">
			<div className="card-header">
				{data.subjectName} / {data.examTypeName}
			</div>
			<div className="card-content">
				{data.cardInfo.map((item, idx) => (
					<div className="card-info" key={idx}>
						<div className="card-info-key">{item.title}</div>
						<div className="card-info-value">
							{item.type === 'date'
								? moment(item.value).format('DD-MM-YYYY HH:mm')
								: item.value}
						</div>
					</div>
				))}
			</div>
			<div className="card-footer">
				{data.appealing && (
					<Button onClick={data?.actions?.[0]?.action} type="primary">
						{data?.actions?.[0]?.title}
					</Button>
				)}
			</div>
		</div>
	);
};

export default StudentExamCard;
